import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth/auth";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
  },
  state: {
    sheet: false,
    sheet_message: "An error has occurred, we are working on a fix.",
    redirect_to_after_login: "",
    loading: false,
    loading_indeterminate: true,
    server_url_clear: "https://api.serpinsider.com",
    // server_url_clear: 'http://localhost:8000',
    // server_url: 'http://localhost:8000/api/s'
    // server_url: 'http://localhost:8000'
  },
  actions: {
    handleAxiosError(ctx, { error, router }) {
      if (error.response.status === 401) {
        ctx.commit("auth/setToken", null);
        localStorage.removeItem("token");
        router.push("/login");
      }
    },
  },
});

export default store;
